/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from "../../Containers/ArgosFlexbox";
import ArgosTextField from "../../Form/TextField/ArgosTextField";
import ArgosButton from "../../Buttons/ArgosButton";
import { useState } from "react";
import { getNodeById } from "../../../pages/CoverageRequirements/ItemDetails/Tabs/CoverageRequirementsTab/LeftPanelComponents/TreeComponent/CoverageRequirementsTreeComponent"
import VAR_COMMON_CONSTANTS from "../../../../constants/globalVariables"

/**
 * TODO: This can be placed in a folder containing reusable components for the whole app (eg could be used in Adas Programs). This is to ensure people don't break it elsewhere.
 * @param props
 * @constructor
 */
const AddNewFolderDialogContent = (props: any) => {
    const isEditFolder: boolean = props?.dialogType  == "edit"
    const contextNodeId = props?.contextNodeId != undefined ? props?.contextNodeId : ""
    const treeData = props?.treeData != undefined ? props?.treeData : {}
    const [error, setError] = useState("");
    const nodeData: any = getNodeById(treeData, contextNodeId)
    const [folderToAdd, setFolderToAdd] = useState(isEditFolder ? nodeData?.name :"");
    const handleFolderAdd = () => {
        const action: string = isEditFolder ? "editFolder" : "addNewFolder"
        const folderData: any = {
            "name": folderToAdd
        }
        props.action(action, folderData);
        props.onClose()
    }
    const onChange = (e:any) => {
        const newValue = e.target.value;
    
        if (!newValue.match(VAR_COMMON_CONSTANTS.VAR_FORBIDDEN_CHARS)) {
          setError("");
        } else {
          setError(VAR_COMMON_CONSTANTS.VAR_FORBIDDEN_CHARS_MSG);
        }
        setFolderToAdd(newValue)
    };
    return (
        <>
        <ArgosFlexbox vertical>
            <ArgosTextField value={folderToAdd} type="text"
                              onChange={onChange}
                              label="Folder Name"
                              helperText={error}
                              error={!!error}
                            />
            <ArgosFlexbox style={{justifyContent: "center"}}>
                <ArgosButton onClick={() => props.onClose()}>
                    Cancel
                </ArgosButton>
                <ArgosButton onClick={() => handleFolderAdd()} disabled={!!error} >
                    { isEditFolder ? "Save": "Add"}
                </ArgosButton>
            </ArgosFlexbox>
        </ArgosFlexbox>
        </>
    )
}
export default AddNewFolderDialogContent;